// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13280(ded5f653ca)-C16/10/2026-14:52:23-B16/10/2026-15:29:02' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13280(ded5f653ca)-C16/10/2026-14:52:23-B16/10/2026-15:29:02",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13280",
  shortHash: "ded5f653ca",
  longHash: "ded5f653ca211f905a355850924104f5a61c70d2",
  dateCommit: "16/10/2026-14:52:23",
  dateBuild: "16/10/2026-15:29:02",
  buildType: "Ansible",
  } ;
